<app-list-view
  [column]="column"
  [canSimpleSearch]="false"
  [data]="rows"
  [count]="count"
  [canEdit]="canEdit"
  [loading]="loading"
  [tabsName]="tabsName"
  [title]="'Admins'"
  [url]="url"
  [actions]="actions"
  [canAdvanceSearch]="true"
  [definedFilters]="definedFilters"
  (filters)="loadDataLive($event)"></app-list-view>
